const styles = {
  button: {
    marginTop: 8,
    marginRight: 8,
  },
};

export default styles;
